import { render, staticRenderFns } from "./SchoolStudent.vue?vue&type=template&id=14682112&scoped=true"
import script from "./SchoolStudent.vue?vue&type=script&lang=js"
export * from "./SchoolStudent.vue?vue&type=script&lang=js"
import style0 from "./SchoolStudent.vue?vue&type=style&index=0&id=14682112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14682112",
  null
  
)

export default component.exports